import { format, parseISO } from 'date-fns'
export const SearchColumns = [
  {
    field: 'created_datetime',
    headerName: 'Created On',
    width: 130,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 130,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 250,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 130,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'state',
    headerName: 'Location',
    width: 130,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'procedure_code',
    headerName: 'Case Type',
    headerClassName: 'super-app-theme--header',
    width: 250,
  },
]
